import React from 'react'
import useStyles from './Styles'
import { ICurrentMediaPanelProps } from '../Interfaces'
import { Grid, Paper, Typography, Link } from '@material-ui/core'
import { Pdf, Link as LinkIcon, DeleteIcon } from 'assets/images'
import { ConfirmAction } from 'smart-components/confirm-action'
const CurrentMediaPanel: React.FC<ICurrentMediaPanelProps> = ({ file, links, isSmall }) => {
  const classes = useStyles()

  const onToggleDialog = (toggleDialog: any, item: any) => {
    if (!item.isSaving) {
      toggleDialog()
    }
  }

  const getItemPanel = (item: any, icon: any, sizeProps: any) => {
    const nameDisplay = item ? `${item.name.charAt(0).toUpperCase()}${item.name.slice(1)}` : ''
    return (
      <Grid
        item
        {...sizeProps}
        className={[classes.mt_30, classes.mediaItemPanel, isSmall ? classes.mediaItemPanelSmall : ''].join(' ')}
      >
        <ConfirmAction
          title="Confirm delete"
          content={`Are you sure you want to delete ${nameDisplay}?`}
          onConfirm={item.onDelete}
        >
          {(_isOpen, toggleDialog) => (
            <Grid container justify="center">
              <Grid
                className={icon === Pdf ? classes.deleteContainerPdf : classes.deleteContainerLink}
                container
                justify="flex-end"
              >
                <img
                  id="media-upload-delete-item-pdf-icon"
                  className={classes.deleteIcon}
                  src={DeleteIcon}
                  alt={'delete-pdf'}
                  onClick={() => onToggleDialog(toggleDialog, item)}
                />
              </Grid>
            </Grid>
          )}
        </ConfirmAction>
        <Grid container justify="center">
          <Link target="blank" href={item.url}>
            <Grid className={classes.pdfImageContainer}>
              <img
                id="media-upload-current-item-pdf-icon"
                className={icon === Pdf ? classes.pdfIcon : classes.linkIcon}
                src={icon}
                alt={'Pointr-pdf'}
              />
            </Grid>

            <Grid container justify="center">
              <Typography id="media-upload-current-item-name-label" className={classes.currentMediaFileName}>
                {nameDisplay}
              </Typography>
            </Grid>
          </Link>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid item className={[classes.currentMediaContainer, isSmall ? classes.currentMediaContainerSmall : ''].join(' ')}>
      <Paper className={classes.paperCurrentMedia}>
        <Typography variant="subtitle1" id="media-upload-current-file-media-label">
          Media
        </Typography>
        <Grid container direction="row" style={{ width: 'auto' }}>
          {file && getItemPanel(file, Pdf, {})}
          {links &&
            links.items.map(link =>
              getItemPanel(
                {
                  ...link,
                  isSaving: links.isSaving,
                  onDelete: () => links.onDelete(links.items.indexOf(link))
                },
                LinkIcon,
                {}
              )
            )}
        </Grid>
      </Paper>
    </Grid>
  )
}

export default CurrentMediaPanel
